// ----------------------------------------------------------------------

const account = {
  displayName: 'Gouse Mohiddin',
  email: 'demo@minimals.cc',
};

export default account;
